<template>
  <div>
    <page-header>
      <div class="row">
        <div class="col-xs-12 text-center">
          <img class="_margin-bottom-20" src="../../assets/results-page/solar.png"
            style="width: 100%; max-width: 500px" />

          <h1 class="text-center center-block _margin-bottom-30" style="max-width: 700px; margin: auto">
            Power Your Home with Solar & Battery Storage
          </h1>

          <uiv-btn type="primary" @click="onExplore">Explore Home Solar & Battery</uiv-btn>
        </div>
      </div>
    </page-header>

    <div class="container _margin-top-10">
      <div class="row">
        <div class="col-md-8 col-md-offset-2">
          <p style="max-width: none">
            Harness the sun's energy and take control of your power usage with a
            solar and battery solution. Reduce reliance on the grid, lower your
            bills, and enjoy uninterrupted energy—even during peak hours or
            cloudy days. With rising energy costs and growing environmental
            concerns, now is the perfect time to switch to solar and battery
            technology. Not only will you save money, but you'll also contribute
            to a cleaner, greener planet.
          </p>
        </div>
      </div>
    </div>

    <div class="page-section">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <img src="../../assets/home/person-1.png" />
            <div class="_margin-bottom-20 visible-xs visible-sm"></div>
          </div>

          <div class="col-md-7">
            <h5 class="_margin-bottom-10">Why Choose Solar & Battery?</h5>
            <ul>
              <li>Generate clean, renewable energy for your home</li>
              <li>
                Store excess power for use during peak hours or when the sun
                isn't shining
              </li>
              <li>
                Reduce reliance on the grid, protecting yourself from energy
                price spikes
              </li>
              <li>
                Lower your monthly electricity bills with smarter energy usage.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="container _margin-top-10">
      <div class="row">
        <div class="col-md-7">
          <h4>Get Started with Your Solar Journey</h4>
          <h6 class="_margin-bottom-0">
            Personalised Solar & Battery Recommendations
          </h6>
          <p class="_margin-top-0 _margin-bottom-30">
            We analyse your home's location, property type, and typical energy
            usage for your type of home to recommend the ideal solar & battery
            system for you.
          </p>

          <h6 class="_margin-bottom-0">Cost & Savings Estimates</h6>
          <p class="_margin-top-0 _margin-bottom-30">
            See how much you could save annually - Our system estimates
            potential savings, helping you understand the long-term financial
            benefits of solar.
          </p>

          <h6 class="_margin-bottom-0">Get a System Cost Estimate</h6>
          <p class="_margin-top-0 _margin-bottom-30">
            We provide an upfront estimate based on typical installation costs
            for your home type.
          </p>

          <h6 class="_margin-bottom-0">Energy Tariffs</h6>
          <p class="_margin-top-0 _margin-bottom-30">
            We match the best Time of Use (ToU) tariffs available in your area
            to maximise savings with solar battery storage.
          </p>

          <h6 class="_margin-bottom-0">Data-Driven Energy Insights</h6>
          <p class="_margin-top-0 _margin-bottom-30">
            Estimating how much solar energy you'll generate and store. Sunlight
            availability at your location - Using irradiation data and industry
            standards. Energy Whole of Market energy tariff data - Helping you
            switch to the best deal on the market.
          </p>

          <h6 class="_margin-bottom-0">Easy Next Steps</h6>
          <p class="_margin-top-0 _margin-bottom-30">
            Enter your postcode to receive a personalised solar & battery
            estimate and arrange a call with one of our expert installers who
            will help you explore your options and find the best solution for
            your home.
          </p>
        </div>

        <div class="col-md-5">
          <img src="../../assets/home/solar-sun.png" class="center-block img-responsive _margin-bottom-20" />
          <uiv-btn type="primary" @click="onExplore" block>Explore Home Solar & Battery</uiv-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import YourHome from '@/components/current-tariff/YourHome';
import PageHeader from '@/components/page-header/PageHeader';

import { mapState } from 'vuex';

export default {
  name: 'SolarBattery',
  mounted() {
    this.$store.dispatch('tracing/addAction', {
      name: 'Action',
      value: 'Viewed'
    });
    this.$store.dispatch('tracing/saveActions');
  },
  computed: {
    ...mapState({
      quote: ({ session }) => session.quote_journey_session
    })
  },
  methods: {
    onExplore() {
      this.quote.evCompare = false;
      this.quote.evOnly = false;
      this.quote.ashp = false;
      this.quote.solar = true;
      this.$store.dispatch('session/setItem', {
        key: 'quote_journey_session',
        value: this.quote
      });

      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Explore Home Solar & Battery' });
      this.$store.dispatch('tracing/saveActions');
      this.$router.push({ name: 'currentTariff' });
    }
  },
  components: {
    YourHome,
    PageHeader
  }
};
</script>

<style lang="scss" scoped>
.page-section {
  padding-top: 25px;
  padding-bottom: 25px;
  background-color: rgba(231, 166, 0, 0.2);

  ul {
    padding-left: 0;
    list-style: none;

    li {
      padding: 10px;
      background-color: #fff;
      margin-bottom: 10px;
      font-size: 20px;
      border-radius: 17px;
    }
  }
}
</style>
